export const toGlCodesOptionsTransformer = (glCodes) =>
  glCodes?.map((glCode) => ({
    value: glCode.number,
    label: `${glCode.number} - ${glCode.description}`,
  }));
